import { signOut } from './index'

export const checkLoginStatus = (data, dispatch) => {
  if (data && data.response && data.response.status === 403) {
    dispatch(signOut())
  }
}
